import styled from "styled-components";

export const ContainerPagina = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FormFiltros = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  justify-content: left;
  align-items: flex-start;
  
  div {
    display: flex;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 100%;

    @media only screen and (max-width: 1200px) {
      flex-direction: column;
      &.botoes {
        flex-direction: row;
      }
    }
  }
`;

export const TabelaConteudo = styled.table`
  width: 780px;
  margin: 15px auto 0;
  padding: 10px;
  border: 1px solid black;

  &.print {
    margin: 15px 0;
    zoom: 90%;
  }
`;

export const AreaData = styled.table`
  width: 730px;
  margin: 5px auto 0;
  padding: 2px;
  border-bottom: 1px solid black;
  `;

export const AreaInfo = styled.table`
  width: 750px;
  margin: 10px auto;
  padding: 2px;

  tr {
    display: flex;
    
    td {
      flex: 1;

      &.containerInfos {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        span {
          text-align: right;
          
          * {
            font-size: 16px;
          }
        }
      }
    }
  }
  
  img {
    height: 95px;
  }
`;

export const InfoCooperativa = styled.table`
  width: 750px;
  margin: 5px auto 0;
  border: 1px solid black;

  tr {
    display: grid;
    grid-template-columns: 40% 20% 20% 20%;
    
    td {
      display: flex;
      flex-direction: column;
      padding: 10px;
      margin: .5px;
      font-size: 11px;
      line-height: 14px;

      strong {
        font-size: 11px;
      }
    }
  }
`;

export const DiscriminacaoVerba = styled.div`
  width: 750px;
  margin: 5px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  padding: 1px;
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
`;

export const AreaCooperado = styled.table`
  width: 750px;
  margin: 5px auto 0;
  
  tr {
    display: grid;
    grid-template-columns: 50% 25% 25%;
    
    td {
      display: flex;
      flex-direction: column;
      border: 1px solid black;
      padding: 0 5px;
      margin: .5px;
      font-size: 11px;
      line-height: 15px;

      strong {
        font-size: 11px;
      }
    }
  }
`;

export const ColunasDescricao = styled.table`
  width: 750px;
  margin: 5px auto 0;
  
  tr {
    display: grid;
    grid-template-columns: 10% 45% 15% 15% 15%;
    
    td {
      text-align: center;
      padding: 1px;
      font-weight: bold;
      border: 1px solid black;
      margin: .5px;
      font-size: 12px;
      line-height: 14px;
    
      * {
        font-size: 12px;
      }
    }
  }
`;

export const LinhasTabela = styled.table`
  width: 750px;
  margin: 0 auto;

  tbody {
    border-right: 1px solid black;
    border-left: 1px solid black;
  }
  
  tr {
    display: grid;
    grid-template-columns: 10% 45% 15% 15% 15%;
    
    td {
      min-height: 18px;
      text-align: center;
      padding: 0px;
      font-size: 12px;
      font-weight: bold;
      border-left: 1px solid black;

      &:nth-child(1) {
        border-left: none;
      }
      * {
        font-size: 12px;
      }
    }
  }
`;

export const ColunasTotal = styled.table`
  width: 750px;
  margin: 0 auto 1px;
  
  tr {
    display: grid;
    grid-template-columns: 70% 15% 15%;
    
    td {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      text-align: center;
      padding: 1px;
      font-weight: 500;
      border: 1px solid black;
      margin: .5px;
      line-height: 13px;
      font-size: 9px;

      strong {
        font-weight: 700;
        font-size: 11px;
      }
      * {
        font-size: 10px;
      }
    }
  }
`;

export const ColunasLiquido = styled.table`
  width: 750px;
  margin: 0 auto 1px;
  
  tr {
    display: grid;
    grid-template-columns: 80% 20%;
    
    td {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      text-align: center;
      padding: 1px;
      font-weight: 500;
      border: 1px solid black;
      margin: .5px;
      line-height: 13px;
      font-size: 9px;

      strong {
        font-weight: 700;
        font-size: 11px;
      }
      * {
        font-size: 10px;
      }

      &#valorLiquido {
        background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      }
    }
  }
`;

export const ColunasImpostos = styled.table`
  width: 750px;
  margin: 0 auto 1px;
  
  tr {
    display: grid;
    grid-template-columns: 55% 25% 20%;
    
    td {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      text-align: center;
      padding: 1px;
      font-weight: 500;
      border: 1px solid black;
      margin: .5px;
      line-height: 13px;
      font-size: 9px;

      strong {
        font-weight: 700;
        font-size: 11px;
      }
      * {
        font-size: 10px;
      }
    }
  }
`;

export const LinhaObservacoes = styled.table`
  width: 750px;
  margin: 0 auto 15px;
  
  tr {
    display: grid;
    grid-template-columns: 100%;
    
    td {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      padding: 4px;
      min-height: 60px;
      font-weight: 500;
      border: 1px solid black;
      margin: .5px;
      line-height: 13px;

      font-weight: 700;
      font-size: 12px;
    }
  }
`;
